import { render, staticRenderFns } from "./jobFrom.vue?vue&type=template&id=35485f0e&scoped=true"
import script from "./jobFrom.vue?vue&type=script&lang=js"
export * from "./jobFrom.vue?vue&type=script&lang=js"
import style0 from "./jobFrom.vue?vue&type=style&index=0&id=35485f0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35485f0e",
  null
  
)

export default component.exports